import jsonRequestHeaders from './factory/jsonRequestHeaders';
import timeZoneContextType from './factory/timeZoneContext';
import timeZoneDefinitionType from './factory/timeZoneDefinitionType';
import extendedPropertyUri from './factory/extendedPropertyUri';
import MapiPropertyType from './contract/MapiPropertyType';

export function getJsonRequestHeader(timeZone?: string) {
    return jsonRequestHeaders({
        RequestServerVersion: 'Exchange2015',
        TimeZoneContext: timeZoneContextType({
            TimeZoneDefinition: timeZoneDefinitionType({
                Id: timeZone != null ? timeZone : 'Pacific Standard Time',
            }),
        }),
    });
}

export function getExtendedPropertyUri(
    propertySetID: string,
    propertyName: string,
    propertyType: MapiPropertyType
) {
    return extendedPropertyUri({
        PropertySetId: propertySetID,
        PropertyName: propertyName,
        PropertyType: propertyType,
    });
}
